import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { SHIPPING_METHOD } from 'domains/consignment-inbound-request/constants/consignment-inbound-request-constants'


const propTypes = {
  shippingMethod: PropTypes.string
}

const ConsignmentInboundRequestShippingMethodBadge = ({ shippingMethod }) => {

  const colorMap = {
    [SHIPPING_METHOD.PICKUP]  : 'primary',
    [SHIPPING_METHOD.DROPOFF] : 'info'
  }

  const color = colorMap[shippingMethod] || 'default'

  return <StatusBadge color={ color } label={ shippingMethod } />
}

ConsignmentInboundRequestShippingMethodBadge.propTypes = propTypes

export default ConsignmentInboundRequestShippingMethodBadge